import { render, staticRenderFns } from "./DialogButton.vue?vue&type=template&id=4af98a37&scoped=true&"
import script from "./DialogButton.vue?vue&type=script&lang=js&"
export * from "./DialogButton.vue?vue&type=script&lang=js&"
import style0 from "./DialogButton.vue?vue&type=style&index=0&id=4af98a37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af98a37",
  null
  
)

export default component.exports